<template>
  <v-row :class="rowClass" justify="space-between">
    <v-col v-bind="responsiveCols">
      <div class="text-h6 grey--text mb-2 body-2">Categorias de Serviços</div>
      <v-autocomplete
        :items="filteredCategoriasServicos"
        v-model="draftCategoriasServicos"
        @blur="setSelectedCategoriasServicos(draftCategoriasServicos)"
        dense
        outlined
        multiple
        :rules="[
          mandatory && draftCategoriasServicos.length === 0
            ? 'Selecione pelo menos uma Categoria'
            : true,
        ]"
      >
        <template v-slot:prepend-item>
          <v-list-item
            ripple
            @mousedown.prevent
            @click="selectAllServiceCategories()"
          >
            <v-list-item-action>
              <v-icon
                :color="
                  draftCategoriasServicos.length ===
                  filteredCategoriasServicos.length
                    ? 'indigo darken-4'
                    : ''
                "
              >
                {{
                  draftCategoriasServicos.length ===
                  filteredCategoriasServicos.length
                    ? "mdi-checkbox-marked"
                    : "mdi-checkbox-blank-outline"
                }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Selecionar todos
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index <= 2">
            <span>
              {{ item.text }}
            </span>
          </v-chip>
          <span v-if="index === 3" class="grey--text text-caption">
            (+{{ draftCategoriasServicos.length - 3 }})
          </span>
        </template>
      </v-autocomplete>
    </v-col>
    <v-col v-bind="responsiveCols">
      <div class="text-h6 grey--text mb-2 body-2">
        Tipos de Serviços
      </div>
      <v-autocomplete
        :items="itemsSelectTiposServicos"
        v-model="draftTiposServicos"
        @blur="selectedTiposServicos = draftTiposServicos"
        dense
        outlined
        multiple
        :rules="[
          mandatory && draftTiposServicos.length === 0
            ? 'Selecione pelo menos um Serviço'
            : true,
        ]"
      >
        <template v-slot:prepend-item>
          <v-list-item
            ripple
            @mousedown.prevent
            @click="selectAllTiposServicos()"
          >
            <v-list-item-action>
              <v-icon
                :color="
                  draftTiposServicos.length === itemsSelectTiposServicos.length
                    ? 'indigo darken-4'
                    : ''
                "
              >
                {{
                  draftTiposServicos.length === itemsSelectTiposServicos.length
                    ? "mdi-checkbox-marked"
                    : "mdi-checkbox-blank-outline"
                }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Selecionar todos
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index <= 8">
            <span> S-{{ item.value }} </span>
          </v-chip>
          <span v-if="index === 9" class="grey--text text-caption">
            (+{{ draftTiposServicos.length - 9 }})
          </span>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
  import IndicadoresServicosV2Service from "@/services/IndicadoresServicosV2Service";

  export default {
    name: "SelectTiposServicos",
    props: {
      rowClass: {
        type: String,
        default: "mx-auto",
      },
      responsiveCols: {
        type: Object,
        default: () => ({
          cols: 12,
          sm: 12,
          md: 6,
          lg: 5,
          xl: 4,
        }),
      },
      defaultCategoriasServicos: {
        type: Array,
        default: () => [],
      },
      defaultTiposServicos: {
        type: Array,
        default: () => [],
      },
      mandatory: {
        type: Boolean,
        default: false,
      },
      validServicos: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        categoriasServicos: [],
        draftTiposServicos: [],
        draftCategoriasServicos: [],
        selectedTiposServicos: [],
        selectedCategoriasServicos: [],
      };
    },
    computed: {
      filteredCategoriasServicos() {
        if (this.validServicos.length === 0) {
          return this.categoriasServicos.map((categoria) => ({
            text: categoria.nome,
            value: categoria.id,
          }));
        }

        return this.categoriasServicos
          .filter((categoria) => {
            const validServices = categoria.tipos_servicos.filter(
              (tipo_servico) => this.validServicos.includes(tipo_servico.codigo)
            );
            return validServices.length > 0;
          })
          .map((categoria) => ({
            text: categoria.nome,
            value: categoria.id,
          }));
      },
      itemsSelectTiposServicos() {
        return this.selectedCategoriasServicos
          .flatMap((categoriaSelecionada) => {
            const categoria = this.categoriasServicos.find(
              (c) => c.id === categoriaSelecionada
            );

            // Se indicado, filtra apenas os serviços liberados (validServicos)
            const tiposServicos = categoria?.tipos_servicos?.filter(
              (tipo_servico) => {
                return this.validServicos.length > 0
                  ? this.validServicos.includes(tipo_servico.codigo)
                  : true;
              }
            );

            return (
              tiposServicos?.map((tipo_servico) => ({
                text: `S-${tipo_servico.codigo}: ${tipo_servico.detalhe_servico.artigo_ren_1000} - ${tipo_servico.detalhe_servico?.nome_servico}`,
                value: tipo_servico.codigo,
              })) || []
            );
          })
          .filter(
            (value, index, self) =>
              self.findIndex((v) => v.value === value.value) === index
          ) // Remove duplicatas
          .sort((a, b) => a.value - b.value);
      },
    },
    methods: {
      arraysIsEqual(firstArray, secondArray) {
        return (
          JSON.stringify(firstArray.toSorted((a, b) => a - b)) ===
          JSON.stringify(secondArray.toSorted((a, b) => a - b))
        );
      },
      getCategoriasServicos() {
        return IndicadoresServicosV2Service.getCategoriasServicos()
          .then((res) => {
            this.categoriasServicos = res;
          })
          .catch((err) => {
            this.$toast.error("Erro ao recuperar categorias de serviços.", "", {
              position: "topRight",
            });
            throw err;
          });
      },
      setInitialServiceCategories() {
        this.draftCategoriasServicos = this.selectedCategoriasServicos = this.filteredCategoriasServicos.map(
          (el) => el.value
        );
      },
      setInitialTiposServicos() {
        this.draftTiposServicos = this.selectedTiposServicos = this.itemsSelectTiposServicos.map(
          (el) => el.value
        );
      },
      initializeDefaults() {
        if (this.defaultCategoriasServicos.length > 0) {
          this.draftCategoriasServicos = [...this.defaultCategoriasServicos];
          this.selectedCategoriasServicos = [...this.defaultCategoriasServicos];
        } else {
          this.setInitialServiceCategories();
        }

        if (this.defaultTiposServicos.length > 0) {
          this.draftTiposServicos = [...this.defaultTiposServicos];
          this.selectedTiposServicos = [...this.defaultTiposServicos];
        } else {
          this.setInitialTiposServicos();
        }
      },
      selectAllServiceCategories() {
        this.$nextTick(() => {
          if (
            this.draftCategoriasServicos.length ===
            this.filteredCategoriasServicos.length
          ) {
            this.draftCategoriasServicos = [];
          } else {
            this.draftCategoriasServicos = this.filteredCategoriasServicos.map(
              (el) => el.value
            );
          }
        });
      },
      selectAllTiposServicos() {
        this.$nextTick(() => {
          if (
            this.draftTiposServicos.length ===
            this.itemsSelectTiposServicos.length
          ) {
            this.draftTiposServicos = [];
          } else {
            this.draftTiposServicos = this.itemsSelectTiposServicos.map(
              (el) => el.value
            );
          }
        });
      },
      setSelectedCategoriasServicos(selectedCategories) {
        if (
          this.arraysIsEqual(
            selectedCategories,
            this.selectedCategoriasServicos
          )
        ) {
          return;
        }

        this.selectedCategoriasServicos = selectedCategories;

        this.selectAllTiposServicosAfterCategoryChange();
      },
      selectAllTiposServicosAfterCategoryChange() {
        const newSelectedServices = this.itemsSelectTiposServicos.map(
          (el) => el.value
        );

        this.draftTiposServicos = newSelectedServices;
        this.selectedTiposServicos = newSelectedServices;
      },
    },
    watch: {
      selectedCategoriasServicos(newValue, oldValue) {
        if (this.arraysIsEqual(newValue, oldValue)) {
          return;
        }

        this.$emit("update:selectedCategoriasServicos", newValue);
      },
      selectedTiposServicos(newValue, oldValue) {
        if (this.arraysIsEqual(newValue, oldValue)) {
          return;
        }

        this.$emit("update:selectedTiposServicos", newValue);
      },
    },
    async created() {
      await this.getCategoriasServicos();

      this.initializeDefaults();
    },
  };
</script>
